import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon/Icon'
import Loader from '../loader/Loader';
import type { ButtonProps } from './Button.types';

import './button.scss';

const Button = ({ text, size, iconName, type, disabled, color, loading, loadingPosition, className, style, onClick }: ButtonProps) => {
  const isDisabled = disabled ? 'sb-button--disabled' : '';
  const onlyIcon = (iconName || loading) && !text ? 'sb-button--icon' : '';
  const position = loadingPosition === 'right' ? 'sb-button--loadingRight' : '';

  const animationClick = (e: any) => {
    const { pageX, pageY } = e;
    const { width, height } = e.target.getBoundingClientRect();

    e.target.style.setProperty("--top", `${(pageY / height) * 100}%`);
    e.target.style.setProperty("--left", `${(pageX / width) * 100}%`);

    const dx = pageX > width / 2 ? pageX : width - pageX;
    const dy = pageY > height / 2 ? pageY : height - pageY;
    const size = Math.sqrt(dx ** 2 + dy ** 2) * 2;
    e.target.style.setProperty("--size", `${size}px`);
  }

  return (
    <button
      className={['sb-button',
        `sb-button--${size}`,
        `sb-button--${type}`,
        `sb-button--${color}`,
        isDisabled,
        onlyIcon,
        position,
        className].join(' ')}
      data-testid="sb-button"
      style={{ ...style }}
      onMouseOver={animationClick}
      onClick={onClick}
    >
      <div
        className="sb-content"
        data-testid="sb-content"
      >
        {loading ?
          <Loader size={16} /> :
          iconName &&
          <Icon
            iconName={iconName}
            size={16}
          />
        }
        {text}
      </div>
    </button>
  );
};

Button.propTypes = {
  /**
 * Button text
 */
  text: PropTypes.string,
  /**
* Size button
*/
  size: PropTypes.oneOf(['sm', 'md', 'default']),
  /**
* IconName
*/
  iconName: PropTypes.string,
  /**
* type
*/
  type: PropTypes.oneOf(['solid', 'outline', 'clear']),
  /**
 * Color of button
 */
  color: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  /**
* className
*/
  className: PropTypes.string,
  /**
* style
*/
  style: PropTypes.object,
  /**
* Disabled
*/
  disabled: PropTypes.bool,
  /**
* is loading?
*/
  loading: PropTypes.bool,
  /**
* Loading position
*/
  loadingPosition: PropTypes.oneOf(['left', 'right']),
  /**
* onClick
*/
  onClick: PropTypes.func,
};

Button.defaultProps = {
  text: "",
  size: "default",
  iconName: "",
  type: "solid",
  disabled: false,
  color: "primary",
  loading: false,
  loadingPosition: "left",
  onClick: () => { },
};

export default Button;